export default __webpack_public_path__ + "static/media/bitmap2.a4f10c47.svg";